import { createApi } from '@reduxjs/toolkit/query/react';
import { backendBaseQuery } from '@shared/api';

export const sendingsApi = createApi({
  reducerPath: 'sendings-api',
  baseQuery: backendBaseQuery,
  endpoints: (build) => ({
    send: build.mutation({
      query: (body) => ({
        url: 'sendings',
        method: 'POST',
        body
      })
    }),
  })
});

export const {
  useSendMutation,
} = sendingsApi; 